import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const BulkUpdateFormStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bulk-update-form",
})`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-inline-end: 48px;
`;
